import React, { createContext } from 'react';
import { node } from 'prop-types';

import { useMarketCheck } from '../hooks/useMarketCheck';
import { GET_RENTAL_MARKET_CHECK_QUERY } from '../utils/queries';

export const defaultContext = {
  data: null,
  loading: false,
  error: '',
  executeRequest: async () => {}
};

export const GetRentalMarketCheckContext = createContext(defaultContext);

const GetRentalMarketCheckProvider = ({ children }) => {

  return (
    <GetRentalMarketCheckContext.Provider
      value={{ ...useMarketCheck() }}
    >
      {children}
    </GetRentalMarketCheckContext.Provider>
  );
};

GetRentalMarketCheckProvider.propTypes = {
  children: node.isRequired
};

GetRentalMarketCheckProvider.dataModel = GET_RENTAL_MARKET_CHECK_QUERY;

export default GetRentalMarketCheckProvider;
